

















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptReceivePaymentResult extends Vue {

  // 入金実績表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public bankAccount: Common.BankAccount = null;
  public startDate: Date = null;
  public endDate: Date = null;
  public onExcelExport :boolean = false;
  public startDateFlag : Common.dateFlags = Common.dateFlags.default;
  public endDateFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
   if ((this.$parent as any).favoriteLoaded == false){         
    var query: Common.ReceivePaymentResultReportTemplateQuery = new Common.ReceivePaymentResultReportTemplateQuery();
    this.$api.execute(query).then(obj => {
      var items: Common.ReportTemplate[] = new Array();
      items = (obj as Common.LoadResult).result;
      if (items.length > 0) this.reportTemplate = items[0];
    });
   }
    this.startDate = new Date().getCalendarDate();
    this.endDate = new Date().getCalendarDate();
    (this.$refs.ReceivePaymentResultDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.ReceivePaymentResultReportQuery = new Common.ReceivePaymentResultReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.segment = this.segment;
    query.counterpart = this.counterpart;
    query.bankAccount = this.bankAccount;
    query.startDate = this.startDate;
    query.endDate = this.endDate;
    query.onExcelExport = this.onExcelExport;
    this.$api.download(query);
  }
}
